import * as React from "react";
import { Input } from "react-ui";
import { useState } from "react";

import { FiasAddress } from "../Utils/FiasAddressUtils";
import { FiasExtendFieldsType, ParsedExtendedFiasField } from "../FiasInput/Types/FiasTypes";
import { IndexField } from "../FiasInput/IndexField/IndexField";
import { FIAS_HANDLE_EDIT_MODE_VALUE_CHANGE } from "../../../metricsAction";
import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { useTrackFiasModalEnter } from "../FiasMetrics";

import { Caption } from "./FiasCustomManualEditors/FiasFnsManualEditor.styles";
import { Root, Row } from "./FiasManualEditor.styles";

interface FiasManualEditorProps {
    value: FiasAddress;
    onValueChange: (nextValue: FiasAddress) => void;
    extendedFields: ParsedExtendedFiasField[];
    focusByEnterOnNextControl: (event: React.KeyboardEvent) => void;
}

export const FiasManualEditor = ({
    onValueChange,
    value,
    extendedFields,
    focusByEnterOnNextControl,
}: FiasManualEditorProps) => {
    const [isChanged, setIsChanged] = useState<boolean>(false);

    useTrackFiasModalEnter("custom");
    const track = useMetrics();

    return (
        <Root>
            {extendedFields.map(field => {
                const onChangeHandler = (e: string) => {
                    onValueChange({ ...value, [field.path]: e });

                    if (!isChanged) {
                        setIsChanged(true);
                        track(FIAS_HANDLE_EDIT_MODE_VALUE_CHANGE);
                    }
                };

                if (field.showInModal === false) {
                    return null;
                }

                return (
                    <Row key={field.path}>
                        <Caption>{field.description}</Caption>
                        {field.type === FiasExtendFieldsType.index ? (
                            <IndexField
                                onChange={onChangeHandler}
                                path={field.path}
                                optional={field.optional}
                                value={value[field.path] ?? ""}
                                skipDefaultValidation={field.skipDefaultValidation}
                            />
                        ) : (
                            <Input
                                onKeyDown={focusByEnterOnNextControl}
                                data-tid={field.path}
                                width={360}
                                value={value[field.path] ?? ""}
                                onValueChange={onChangeHandler}
                            />
                        )}
                    </Row>
                );
            })}
        </Root>
    );
};
